/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alerts-container[_ngcontent-%COMP%]{z-index:9999;position:relative}.alerts-inner-container[_ngcontent-%COMP%]{position:absolute;top:0;left:0;right:0;padding:.5rem 1rem 0}"];
export { styles as styles };
